import createConjunctionsFetcher from "./conjunctions";
import { createUseDetail, createUseFetchWithConfig } from "../helpers/hooks";
import { createDetailFetcher } from "../helpers/fetchers";
import { createUseItems } from "../configuration/fetchHooks";
import createItemFetcher from "../helpers/item";
import { combineDucks } from "../helpers/combineDucks";
import { createPager } from "../helpers/pager";

// CONJUNCTION DETAILS
const conjunctionDetailFetcher = () => createDetailFetcher("CONJUNCTION");
export const conjunctionDetail = conjunctionDetailFetcher();
export const useConjunctionDetail = createUseDetail(
  conjunctionDetail,
  (state) => state.conjunctionDetail
);

// CONJUNCTIONS
export const conjunctions = createConjunctionsFetcher({
  storeId: "CONJUNCTIONS",
  computeURL: () => "api/v1/conjunctions",
});
export const { getPage: getConjunctionsPage, getCount: getConjunctionRows } =
  createPager("/api/v1/conjunctions");

// FLEET CONJUNCTIONS
export interface FleetConjunctionsConfig {
  organization?: string;
}

const fleetConjunctionsUrlComputer = (config?: FleetConjunctionsConfig) => {
  const organization = config?.organization?.trim();
  const queryParams = organization
    ? `?organization=${encodeURIComponent(organization)}`
    : "";

  return `/api/v1/conjunctions/fleet-status${queryParams}`;
};

export const fleetConjunctions = createConjunctionsFetcher({
  storeId: "FLEET_CONJUNCTIONS",
  computeURL: fleetConjunctionsUrlComputer,
});
export const useFleetConjunctions = createUseItems(
  fleetConjunctions,
  (state) => state.fleetConjunctions
);

// CDM
export type ConjIdConfig = string;

export interface CDMInfo {
  id: string;
  operator: string;
  filename: string;
  fileContent: string;
}

const conjCDMUrlBuilder = (id: ConjIdConfig) => {
  return `/api/v1/conjunctions/${id}/cdm`;
};

const conjunctionCDMId = (id: ConjIdConfig) => {
  return `conjunction_${id}_cdm`;
};

export const conjCDMFetcher = createItemFetcher<ConjIdConfig, any>(
  conjCDMUrlBuilder,
  "CONJ_CDM",
  conjunctionCDMId
);

export const useConjunctionCDM = createUseFetchWithConfig<
  ConjIdConfig,
  CDMInfo
>(conjCDMFetcher, (state) => state.conjunctionCDM.cdm);

export const conjCDMDuck = combineDucks({
  cdm: conjCDMFetcher,
});

export interface OPMInfo {
  id: number;
  operator: string;
  filename: string;
  fileContent: string;
}

const conjOPMUrlBuilder = (id: ConjIdConfig) => {
  return `/api/v1/conjunctions/${id}/opm`;
};

const conjunctionOPMId = (id: ConjIdConfig) => {
  return `conjunction_${id}_opm`;
};

export const conjOPMFetcher = createItemFetcher<ConjIdConfig, any>(
  conjOPMUrlBuilder,
  "CONJ_OPM",
  conjunctionOPMId
);

export const useConjunctionOPM = createUseFetchWithConfig<
  ConjIdConfig,
  OPMInfo
>(conjOPMFetcher, (state) => state.conjunctionOPM.opm);

export const conjOPMDuck = combineDucks({
  opm: conjOPMFetcher,
});
